import { PaymentPlanResource, PromotionResource } from "@/interfaces";

/**
 * The promotions a plan can still earn the customer.
 *
 * The API attaches these per plan (PaymentPlanForContractAction), so a discount
 * only exists for someone who can reach the Payment Agreement step and pick the
 * plan carrying it. Everything the flow says about available discounts — the
 * summary banner, the panel above the contract, the badges on the plan list —
 * reads through here so the three cannot disagree.
 */
export const planEligiblePromotions = (
  plan?: PaymentPlanResource | null
): PromotionResource[] => plan?.relationships?.eligiblePromotions?.data ?? [];

export const planHasEligiblePromotion = (
  plan?: PaymentPlanResource | null
): boolean => planEligiblePromotions(plan).length > 0;

/**
 * Whether any plan the customer can still pick carries a discount.
 *
 * False while the plans are loading and false if the request fails, which is the
 * safe way round: promising a discount that never materialises is what sent MRA
 * customers to the phone (FD-7410).
 */
export const hasEligiblePromotions = (
  paymentPlans?: PaymentPlanResource[] | null
): boolean => (paymentPlans ?? []).some(planHasEligiblePromotion);
